/* ============================================
   Configuración (panel del partner)

   Todo lo que se toca una vez y no es "yo": los datos de la empresa, el
   equipo que entra a la cuenta, la apariencia y las integraciones. Antes
   estaba repartido entre Ajustes (apariencia y WhatsApp) y Mi perfil (la
   empresa), que es justo el lugar donde nadie lo busca.

   Mismo patrón de sub-navegación que el perfil del portal: menú a la
   izquierda y la sección a la derecha, con rutas propias para que cada una
   sea enlazable.
   ============================================ */
import { NavLink, Outlet } from 'react-router-dom'
import { Breadcrumbs } from '@/components/ui'
import { PerfilProvider } from '@/pages/portal/perfil/perfil-contexto'

const SECCIONES = [
  {
    slug: 'general',
    label: 'General',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06A1.65 1.65 0 004.6 15a1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 009 4.6a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06A1.65 1.65 0 0019.4 9v0a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z" />
      </svg>
    ),
  },
  {
    slug: 'empresa',
    label: 'Datos de la empresa',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21h18" /><path d="M5 21V7l8-4v18" /><path d="M19 21V11l-6-4" /><path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01" />
      </svg>
    ),
  },
  {
    slug: 'pipeline',
    label: 'Pipeline',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="5" height="16" rx="1" /><rect x="10" y="4" width="5" height="11" rx="1" /><rect x="17" y="4" width="4" height="7" rx="1" />
      </svg>
    ),
  },
  {
    slug: 'equipo',
    label: 'Equipo',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" />
      </svg>
    ),
  },
]

export default function PartnerConfiguracion() {
  return (
    <PerfilProvider>
      <div className="portal-page-enter pp-wrap pp-wrap--ancho">
        <Breadcrumbs items={[{ label: 'Configuración' }]} />

        <div className="pp-layout">
          <nav className="pp-subnav" aria-label="Secciones de configuración">
            {SECCIONES.map(s => (
              <NavLink key={s.slug} to={`/partner/ajustes/${s.slug}`} className={({ isActive }) => `pp-subnav-link ${isActive ? 'active' : ''}`}>
                <span className="pp-subnav-icon">{s.icon}</span>
                {s.label}
              </NavLink>
            ))}
          </nav>

          <section className="pp-section">
            <Outlet />
          </section>
        </div>
      </div>
    </PerfilProvider>
  )
}
